import request from '@/utils/request';
/* 列表 */
export function jgList(data) {
  return request({
    url: '/jin/gang/qu/queryJinGangQuPageList',
    method: 'POST',
    data
  });
}
/* 增加 */
export function jgAdd(data) {
  return request({
    url: '/jin/gang/qu/saveJinGangQu',
    method: 'POST',
    data
  });
}
/* 修改 */
export function jgEdit(data) {
  return request({
    url: '/jin/gang/qu/updateJinGangQu',
    method: 'POST',
    data
  });
}
/* 修改中的信息展示 */
export function jgInfo(data) {
  return request({
    url: '/jin/gang/qu/fetchJinGangQuDetailById',
    method: 'POST',
    data
  });
}
/* 删除 */
export function jgDel(data) {
  return request({
    url: '/jin/gang/qu/removeJinGangQuById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/jg.js